/**
 *flatPickr 控件事件列表
 * @returns {Function}
 */
const eventListPlugin = function (pluginConfig) {
    var defaultConfig = {
        text: '',
    };

    var config = {};
    for (var key in defaultConfig) {
        config[key] = pluginConfig && pluginConfig[key] !== undefined ? pluginConfig[key] : defaultConfig[key];
    }

    let eventListContainer;

    return function (fp) {
        if (fp.config.noCalendar || fp.isMobile) return {};
        return {
            onReady: function onReady() {
                eventListContainer = fp._createElement(
                "div",
                "",
                ""
                );
                eventListContainer.tabIndex = -1;
                /* 初始化时增加一个dom节点 */ 
                eventListContainer.innerHTML += `
                    <div style="padding:5px;color:#9599AD;">
                        <div class="mb-1" style="text-align: left;">体检报告:</div>
                        <div class="d-flex  align-items-center justify-content-between fs-13" id='instanceReport'>

                        </div>
                    </div>
                    `;
        
                // confirmContainer.addEventListener("click", fp.close);
                fp.calendarContainer.appendChild(eventListContainer);
        
                fp.loadedPlugins.push("eventList");
            }
        };
    };
}

export default eventListPlugin